module.exports = "/_next/static/images/43cbb89918b3f1501535deed358bbf62-card.svg";